module.exports = __webpack_public_path__ + "img/0127.450b3dc2.png";